import axios from 'axios';

const ajax = axios.create({
    // baseURL: (process.env.VUE_APP_API_URL !== undefined) ? process.env.VUE_APP_API_URL : 'https://api.straalstudio.be/'
    baseURL : 'https://api.straalstudio.be/'
    //baseURL : 'http://localhost:8000/',
    //baseURL : 'http://api.straalstudio.local/'
});

export default ajax